import { ADDRESS_LINES, EMAIL, PHONE } from "./data.js";

export const SITE_URL = "https://www.biz360compliance.com";

export function getOrganizationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "AccountingService",
    "@id": `${SITE_URL}/#organization`,
    "name": "Biz360 Compliance",
    "legalName": "Biz360 Compliance",
    "alternateName": "Biz360",
    "url": SITE_URL,
    "logo": `${SITE_URL}/logo.png`,
    "image": `${SITE_URL}/image.png`,
    "description": "Expert-led business registration, GST compliance, income tax filing, corporate ROC governance, accounting and legal licensing advisory across India with regional presence in Pune, Mumbai, Parbhani and Maharashtra.",
    "telephone": PHONE,
    "email": EMAIL,
    "priceRange": "₹₹",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": ADDRESS_LINES.join(", "),
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "postalCode": "411004",
      "addressCountry": "IN"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 18.5089,
      "longitude": 73.8340
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        "opens": "09:30",
        "closes": "19:00"
      }
    ],
    "areaServed": [
      { "@type": "Country", "name": "India" },
      { "@type": "State", "name": "Maharashtra" },
      { "@type": "City", "name": "Pune" },
      { "@type": "City", "name": "Parbhani" },
      { "@type": "City", "name": "Mumbai" },
      { "@type": "City", "name": "Chhatrapati Sambhajinagar" },
      { "@type": "City", "name": "Nagpur" },
      { "@type": "City", "name": "Nanded" },
      { "@type": "City", "name": "Latur" },
      { "@type": "City", "name": "Nashik" },
      { "@type": "City", "name": "Kolhapur" }
    ],
    "sameAs": [
      "https://wa.me/919067368357"
    ]
  };
}

export function getWebSiteSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": `${SITE_URL}/#website`,
    "url": SITE_URL,
    "name": "Biz360 Compliance",
    "description": "Comprehensive corporate legal, tax, GST, and business registration portal for Indian businesses.",
    "publisher": {
      "@id": `${SITE_URL}/#organization`
    },
    "inLanguage": "en-IN"
  };
}

export function getServiceSchema(service, canonicalUrl) {
  if (!service) return null;
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    "@id": `${canonicalUrl}#service`,
    "name": service.title,
    "serviceType": service.category,
    "category": service.sub_category || service.category,
    "description": service.intro ? service.intro.slice(0, 300) : service.subtitle,
    "provider": {
      "@type": "AccountingService",
      "name": "Biz360 Compliance",
      "@id": `${SITE_URL}/#organization`,
      "url": SITE_URL,
      "telephone": PHONE
    },
    "areaServed": [
      { "@type": "Country", "name": "India" },
      { "@type": "State", "name": "Maharashtra" },
      { "@type": "City", "name": "Pune" },
      { "@type": "City", "name": "Parbhani" },
      { "@type": "City", "name": "Mumbai" }
    ],
    "url": canonicalUrl,
    "termsOfService": `${SITE_URL}/terms`
  };
}

export function getFAQPageSchema(faqs) {
  if (!faqs || !Array.isArray(faqs) || faqs.length === 0) return null;
  const validFaqs = faqs.filter(faq => (faq.q || faq.question) && (faq.a || faq.answer));
  if (validFaqs.length === 0) return null;
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": validFaqs.map(faq => ({
      "@type": "Question",
      "name": (faq.q || faq.question || "").trim(),
      "acceptedAnswer": {
        "@type": "Answer",
        "text": (faq.a || faq.answer || "").trim()
      }
    }))
  };
}

export function getArticleSchema(blog, canonicalUrl) {
  if (!blog) return null;
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    "@id": `${canonicalUrl}#article`,
    "headline": blog.title,
    "description": blog.subtitle || (blog.intro ? blog.intro.slice(0, 200) : ""),
    "image": blog.img ? [blog.img] : [`${SITE_URL}/image.png`],
    "url": canonicalUrl,
    "inLanguage": "en-IN",
    "author": {
      "@type": "Organization",
      "name": "Biz360 Compliance Editorial Team",
      "url": SITE_URL
    },
    "publisher": {
      "@type": "Organization",
      "name": "Biz360 Compliance",
      "logo": {
        "@type": "ImageObject",
        "url": `${SITE_URL}/logo.png`
      }
    },
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": canonicalUrl
    }
  };
}
